import { render, staticRenderFns } from "./StarsEffect.vue?vue&type=template&id=4caa04f4&scoped=true&"
import script from "./StarsEffect.vue?vue&type=script&lang=js&"
export * from "./StarsEffect.vue?vue&type=script&lang=js&"
import style0 from "./StarsEffect.vue?vue&type=style&index=0&id=4caa04f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4caa04f4",
  null
  
)

export default component.exports